enum SupportType {
  CONTACT = 'CONTACT',
  FEEDBACK = 'FEEDBACK',
  ISSUE_REPORTING = 'ISSUE_REPORTING',
}

export default SupportType;
